import {} from "../net/index.js";
import { formatNode } from "../node/formatNode.js";
import {} from "./Port.js";
export function formatPort(net, port) {
    if (port.isPrincipal) {
        return `!${port.name}-(${formatNode(net, port.node)})`;
    }
    else {
        return `${port.name}-(${formatNode(net, port.node)})`;
    }
}
//# sourceMappingURL=formatPort.js.map